var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnderReview = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M10.666 7.333h-2v-2c0-.368-.298-.666-.666-.666-.368 0-.667.298-.667.666V8c0 .369.299.667.667.667h2.666c.369 0 .667-.298.667-.667 0-.369-.298-.667-.667-.667zm-2.666 6c-2.941 0-5.334-2.392-5.334-5.333C2.666 5.06 5.06 2.667 8 2.667c2.94 0 5.333 2.392 5.333 5.333 0 2.94-2.393 5.333-5.333 5.333zm0-12C4.324 1.333 1.333 4.324 1.333 8c0 3.676 2.99 6.667 6.667 6.667 3.676 0 6.666-2.991 6.666-6.667 0-3.676-2.99-6.667-6.666-6.667z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnderReview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/under_review.f250662e.svg";
export { ForwardRef as ReactComponent };